import AddPostForm from './AddPostForm.js';
import autoBind from 'react-autobind';
import Clear from 'material-ui/svg-icons/content/clear';
import {connect} from 'react-redux';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Dialog from 'material-ui/Dialog';
import {getCurrentUserId} from '../../authentication/selectors';
import IconButton from 'material-ui/IconButton';
import {Map} from 'immutable';
import muiTheme from '../../../styles/teamologyTheme';
import {closeAddPostDialog, openAddPostDialog, resetAddPostForm} from '../actions';
import React, {Component, PropTypes} from 'react';

class AddPostButtonWeb extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  handleCloseDialog() {
    const {closeAddPostDialog, resetAddPostForm} = this.props;
    resetAddPostForm();
    closeAddPostDialog();
  }

  render() {
    const {addPostDialogIsOpen, model, openAddPostDialog, userId} = this.props;

    const dialogContentStyle = {
      maxWidth: '50%',
      minWidth: '700px',
    };

    const dialogBodyStyle = {
      overflowY: 'scroll',
    };

    return (
      <div className="add-post-button-container">
        <IconButton iconStyle={muiTheme.addPostButton} onTouchTap={openAddPostDialog}><ContentAdd /></IconButton>
        <Dialog
          className="add-post-dialog"
          modal
          open={addPostDialogIsOpen}
          bodyStyle={dialogBodyStyle}
          contentStyle={dialogContentStyle}
          title={
            <div className="title">
              <div>Add Content</div>
              <div><IconButton onClick={this.handleCloseDialog} iconStyle={{color: muiTheme.palette.primary1Color}}><Clear /></IconButton></div>
            </div>
          }>
          <AddPostForm userId={userId} model={model} onCancel={this.handleCloseDialog} onSubmitSuccess={this.handleCloseDialog} />
        </Dialog>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {addPostForm, addPostDialog} = state.features.newCommunityPost.pages;

  return {
    addPostDialogIsOpen: addPostDialog.get('addPostDialogIsOpen'),
    model: addPostForm.get('model'),
    userId: getCurrentUserId(state),
  };
}

AddPostButtonWeb.propTypes = {
  addPostDialogIsOpen: PropTypes.bool.isRequired,
  closeAddPostDialog: PropTypes.func.isRequired,
  model: PropTypes.instanceOf(Map).isRequired,
  openAddPostDialog: PropTypes.func.isRequired,
  resetAddPostForm: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
};

export default connect(
  mapStateToProps,
  {
    closeAddPostDialog,
    openAddPostDialog,
    resetAddPostForm,
  }
)(AddPostButtonWeb);



// WEBPACK FOOTER //
// ./app/features/newCommunityPost/components/AddPostButtonWeb.js